<template>
  <v-container>
    <v-row>
      <v-col>
        <p class="text-body-1 mb-3">
          <strong>West Wind Automotive</strong><br />
          351 Valencia Street<br />
          San Francisco, CA 94103<br />
          <a :href="`tel:${contactPhone}`" class="text-white">{{
            contactPhone
          }}</a>
        </p>

        <p class="text-body-1 mb-3">
          <a
            class="text-white"
            :href="`mailto:${infoEmail}?subject=Questions`"
            >{{ infoEmail }}</a
          >
        </p>

        <p class="text-body-2 mb-3">
          Copyright © {{ year }} Dynamic Motors, Inc. All rights reserved.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
const contactPhone = import.meta.env.VITE_PHONE
const infoEmail = import.meta.env.VITE_EMAIL
const year = new Date().getFullYear()
</script>
